module.exports = __webpack_public_path__ + "img/p3.5d65bc36.png";